var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('KeyVisual'),_c('ProductsBlock'),_c('ProductsMainline',{attrs:{"id":"products"}}),_c('SeriesBlockNew'),(0)?_c('VideoBlock',{attrs:{"id":"series"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }